export const EMPTY_VALUES = ['', null, undefined]
